class HumbleScentsHero extends HTMLElement {
  #slides;
  #filters;
  #activeIndex = 0;

  connectedCallback() {
    this.#slides = this.querySelectorAll('.humble-scents-hero__slide');
    this.#filters = this.querySelectorAll('.humble-scents-hero__filter[data-filter-index]');

    for (const filter of this.#filters) {
      filter.addEventListener('click', this.#onFilterClick);
    }
  }

  disconnectedCallback() {
    for (const filter of this.#filters ?? []) {
      filter.removeEventListener('click', this.#onFilterClick);
    }
  }

  #onFilterClick = (event) => {
    const filter = event.currentTarget;
    const index = parseInt(filter.dataset.filterIndex, 10);

    if (index === this.#activeIndex) return;

    this.#activateIndex(index);
  };

  #activateIndex(index) {
    let activeFamily = '';
    for (const slide of this.#slides) {
      slide.classList.toggle(
        'humble-scents-hero__slide--active',
        parseInt(slide.dataset.slideIndex, 10) === index
      );
    }

    for (const filter of this.#filters) {
      const isActive = parseInt(filter.dataset.filterIndex, 10) === index;
      filter.classList.toggle('humble-scents-hero__filter--active', isActive);

      if (filter.tagName === 'BUTTON') {
        filter.setAttribute('aria-pressed', String(isActive));
      }

      if (isActive) {
        activeFamily = (filter.dataset.family || '').trim().toLowerCase();
      }
    }

    this.#activeIndex = index;

    // Tell the scents grid (or anything else listening) which family is now
    // selected. Empty string = "ALL", restore the full list.
    document.dispatchEvent(
      new CustomEvent('humble-scents:filter', { detail: { family: activeFamily } })
    );
  }
}

customElements.define('humble-scents-hero', HumbleScentsHero);
